const initialState = {
    'Billing Batches':'0',
    'Denied Claims':'0',
    'Missing Acknowledgments':'0',
    'No Response Claims':'0',
    'All Tasks': '0',
    'My Tasks': '0',
    'Patient Intake': '0',
    'Unsigned Encounters': '0',
    'Pending Superbill/Claims': 0,
    'Follow-up Claims': 0
}

const AccountReceivablesCountReducer = ( state = initialState, action) => {
    switch(action.type){

        case 'BILLING_BATCHES' : return {...state, 'Billing Batches': action.payload };
        case 'Missing_Acknowledgments' : return {...state, 'Missing Acknowledgments': action.payload };
        case 'DENIED_CLAIMS' : return {...state, 'Denied Claims': action.payload };
        case 'NO_RESPONSE_CLAIMS' : return {...state, 'No Response Claims': action.payload };
        case 'FOLLOW_UP_CLAIMS' : return {...state, 'Follow-up Claims': action.payload };
        case 'MyTasks' : return {...state, 'My Tasks': action.payload };
        case 'AllTasks' : return {...state, 'All Tasks': action.payload };
        case 'IntakeTasks' : return {...state, 'Patient Intake': action.payload };
        case 'UnsignedTasks' : return {...state, 'Unsigned Encounters': action.payload };
        case 'PendingSuperbills' : return {...state, 'Pending Superbill/Claims': action.payload };

        default: return state;
    }
}

export default AccountReceivablesCountReducer
